import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api', // Use a relative path to ensure same-origin requests
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
